"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/Link.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PieChart = require("@mui/x-charts/PieChart");
var _Switch = _interopRequireDefault(require("@mui/material/Switch"));
var _Stack = _interopRequireDefault(require("@mui/material/Stack"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _react = require("react");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : KpiChart.js
* Description : Ce fichier contient la définition du composant KpiChart 
*               Ce composant est un PieChart personnalisé de la librairie MuiMaterial
* Date de création : 31 juillet 2026
*/ /* CSS et assets */ /* Bibliothèques et composants */ /* Hook */ /**
* KpiChart : ce composant est un PieChart personnalisé de la librairie MuiMaterial
*
* Type : composant 
*
* Parametres : 
*  - chartData -- données du graphique
*  - colorLabel -- couleur du texte des labels
*  - graphWidth -- largeur du graphique
*  - graphHeight -- hauteur du graphique
*  - graphMargin -- marge du graphique
*/
function KpiChart(_ref) {
  var chartData = _ref.chartData,
    colorLabel = _ref.colorLabel,
    graphWidth = _ref.graphWidth,
    graphHeight = _ref.graphHeight,
    graphMargin = _ref.graphMargin;
  // Define useState hooks
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    total = _useState4[0],
    setTotal = _useState4[1];

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  var switchChange = function switchChange(event) {
    setChecked(event.target.checked);
  };
  function computeTotal(chart_data) {
    var totalQuantity = 0;
    var _iterator = _createForOfIteratorHelper(chart_data),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var data = _step.value;
        totalQuantity = totalQuantity + data['value'];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (totalQuantity === 0) {
      totalQuantity = 1;
    }
    setTotal(totalQuantity);
  }

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    if (checked === true) {
      computeTotal(chartData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
      className: "margin-left",
      direction: "row",
      spacing: 1,
      sx: {
        alignItems: 'center'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography["default"], {
        className: "table-label",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          children: "Affichage : "
        }), "Quantit\xE9"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Switch["default"], {
        checked: checked,
        onChange: switchChange,
        inputProps: {
          'aria-label': 'controlled'
        },
        className: "green-switch"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        className: "table-label",
        children: "Pourcentage"
      })]
    }), checked === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PieChart.PieChart, {
      series: [{
        arcLabel: function arcLabel(item) {
          return "".concat(item.value);
        },
        arcLabelMinAngle: 1,
        data: chartData,
        labelPosition: 'outside',
        labelLineLength: 10 // Longueur de la ligne reliant le label au segment
        //labelLineOffset: 5,    // Décalage de la ligne par rapport au segment
      }],
      sx: _defineProperty({}, "& .".concat(_PieChart.pieArcLabelClasses.root), {
        fontSize: '20px',
        fill: colorLabel
      }),
      width: graphWidth,
      height: graphHeight,
      margin: graphMargin
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_PieChart.PieChart, {
      series: [{
        arcLabel: function arcLabel(item) {
          return "".concat(Math.round(item.value * 100 / total), "%");
        },
        arcLabelMinAngle: 1,
        data: chartData,
        labelPosition: 'outside',
        labelLineLength: 10 // Longueur de la ligne reliant le label au segment
        //labelLineOffset: 5,    // Décalage de la ligne par rapport au segment
      }],
      sx: _defineProperty({}, "& .".concat(_PieChart.pieArcLabelClasses.root), {
        fontSize: '20px',
        fill: colorLabel
      }),
      width: graphWidth,
      height: graphHeight,
      margin: graphMargin
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
KpiChart.propTypes = {
  colorLabel: _propTypes["default"].string
};
var _default = exports["default"] = KpiChart;